<!-- 收款台操作 -->
<template>
   <div class="store-modal-content">
      <div class="data_action_form">
         <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
            <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
               :tabslist="formDataList" @tabs="
                  (val) => {
                     showTabs = val
                  }
               ">
               <template slot="tabs" slot-scope="scope">
                  <div class="table_content_box">
                     <!-- 主信息 -->
                     <div v-if="scope.index == 0" class="main-layout">
                        <!-- 左侧区域：表单 + 单品特价设置 -->
                        <div class="left-section">
                           <!-- 表单区域 -->
                           <div class="form-section">
                              <el-form size="mini" inline :model="sendDataInfo" label-width="150px" ref="sendDataInfo"
                                 :show-message="false" :inline-message="false">

                                 <el-form-item label="优惠券名称" prop="yhqName"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('优惠券名称')"
                                       v-html="$common.htmlLabel('优惠券名称')"></label>
                                    <el-input class="form_codition" v-model.trim="sendDataInfo.yhqName"
                                       :maxlength="$store.state.inputLength" placeholder="填写优惠券名称"></el-input>
                                 </el-form-item>
                                 <el-form-item label="使用期限(天)" prop="limitDay"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('使用期限(天)')"
                                       v-html="$common.htmlLabel('使用期限(天)')"></label>
                                    <el-input class="form_codition" v-model.number="sendDataInfo.limitDay"
                                       :maxlength="$store.state.inputLength" placeholder="填写使用期限（自发放后有效期）" type="number"
                                       :min="0"></el-input>
                                 </el-form-item>
                                 <el-form-item label="优惠券描述" prop="yhqDesc"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('优惠券描述')"
                                       v-html="$common.htmlLabel('优惠券描述')"></label>
                                    <el-input type="textarea" v-model.trim="sendDataInfo.yhqDesc"
                                       :maxlength="$store.state.inputLength" style="width: 600px !important;"
                                       placeholder="填写优惠券描述"></el-input>
                                 </el-form-item>


                                 <el-form-item label="开始日期" prop="startDate"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('开始日期')"
                                       v-html="$common.htmlLabel('开始日期')"></label>
                                    <el-date-picker v-model="sendDataInfo.startDate" type="date" placeholder="选择开始日期"
                                       value-format="timestamp" class="form_codition">
                                    </el-date-picker>
                                 </el-form-item>

                                 <el-form-item label="结束日期" prop="endDate"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('结束日期')"
                                       v-html="$common.htmlLabel('结束日期')"></label>
                                    <el-date-picker v-model="sendDataInfo.endDate" type="date" placeholder="选择结束日期"
                                       value-format="timestamp" class="form_codition">
                                    </el-date-picker>
                                 </el-form-item>
                                 <div>
                                    <el-form-item label="每日开始时间" prop="dayStartTime"
                                       :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                       <label slot="label" :style="$common.labelStyle('每日开始时间')"
                                          v-html="$common.htmlLabel('每日开始时间')"></label>
                                       <el-time-picker v-model="sendDataInfo.dayStartTime" placeholder="选择开始时间"
                                          value-format="HH:mm:ss" class="form_codition">
                                       </el-time-picker>
                                    </el-form-item>
                                    <el-form-item label="每日结束时间" prop="dayEndTime"
                                       :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                       <label slot="label" :style="$common.labelStyle('每日结束时间')"
                                          v-html="$common.htmlLabel('每日结束时间')"></label>
                                       <el-time-picker v-model="sendDataInfo.dayEndTime" placeholder="选择结束时间"
                                          value-format="HH:mm:ss" class="form_codition">
                                       </el-time-picker>
                                    </el-form-item>
                                 </div>

                                 <el-form-item label="会员要求" prop="memReq"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('会员要求')"
                                       v-html="$common.htmlLabel('会员要求')"></label>

                                    <el-select v-model.number="sendDataInfo.memReq" placeholder="选择会员要求"
                                       class="form_codition" @change="handleMemberTypeChange">
                                       <!-- <el-option label="不限" :value=1></el-option> -->
                                       <el-option label="会员卡类型" :value=2></el-option>
                                       <!-- <el-option label="会员" value="会员"></el-option> -->
                                       <el-option label="会员积分" :value=3></el-option>
                                    </el-select>
                                 </el-form-item>

                                 <el-form-item v-if="sendDataInfo.memReq === 3" label="积分要求" prop="memReqPoint"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]">
                                    <label slot="label" :style="$common.labelStyle('积分要求')"
                                       v-html="$common.htmlLabel('积分要求')"></label>
                                    <el-input v-model.number="sendDataInfo.memReqPoint" type="number" :min="0"
                                       placeholder="请输入积分要求" class="form_codition"></el-input>
                                 </el-form-item>

                                 <div>
                                    <el-form-item v-if="sendDataInfo.memReq === 2" label="选择会员卡类型"
                                       :rules="[{ required: true, trigger: ['blur', 'change'] }]"
                                       style="width: 100%; display: block;">
                                       <label slot="label" :style="$common.labelStyle('选择会员卡类型')"
                                          v-html="$common.htmlLabel('选择会员卡类型')"></label>
                                       <div class="card-type-selection">
                                          <div class="selection-header">
                                             <span class="selection-title">已选择 {{ selectedCardTypes.length }}/{{
                                                cardTypeList.length }} 个会员卡类型</span>

                                          </div>
                                          <div class="card-type-table">
                                             <div class="table-header">
                                                <div class="header-checkbox">
                                                   <el-checkbox
                                                      :indeterminate="selectedCardTypeIds.length > 0 && selectedCardTypeIds.length < cardTypeList.length"
                                                      v-model="isAllSelected" @change="toggleAllCardTypes">

                                                   </el-checkbox>
                                                </div>
                                                <div class="header-code">卡类型编号</div>
                                                <div class="header-name">卡类型名称</div>
                                                <div class="header-mzDiscount">扣率</div>
                                             </div>
                                             <div class="card-type-list">
                                                <div class="card-type-item" v-for="item in cardTypeList"
                                                   :key="item.capId">
                                                   <div class="item-checkbox">
                                                      <el-checkbox :value="selectedCardTypeIds.includes(item.capId)"
                                                         @change="(checked) => handleSingleCardTypeChange(item.capId, checked)">
                                                      </el-checkbox>
                                                   </div>
                                                   <div class="item-code">{{ item.capCode }}</div>
                                                   <div class="item-name">{{ item.capName }}</div>
                                                   <div class="item-mzDiscount">
                                                      <span v-if="item.isDiscont" class="card-mzDiscount">
                                                         {{ (item.discount * 10).toFixed(0) }}折
                                                      </span>
                                                      <span v-else class="card-no-mzDiscount">无折扣</span>
                                                   </div>
                                                </div>
                                             </div>

                                          </div>
                                       </div>
                                    </el-form-item>
                                 </div>
                                 <el-form-item label="促销周期" prop="mzWeekDays" id="mzMonthDays"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]"
                                    style="width: 100%; display: block;">
                                    <label slot="label" :style="$common.labelStyle('促销周期')"
                                       v-html="$common.htmlLabel('促销周期')"></label>
                                    <el-checkbox-group v-model="sendDataInfo.mzWeekDays">
                                       <el-checkbox-button v-for="item in mzWeekDays" :label="item.value"
                                          :key="item.value">{{ item.label }}</el-checkbox-button>
                                    </el-checkbox-group>
                                 </el-form-item>
                                 <el-form-item label="促销日期" prop="mzMonthDays" id="mzMonthDays"
                                    :rules="[{ required: true, trigger: ['blur', 'change'] }]" style="width: 100%;">

                                    <el-checkbox-group v-model="sendDataInfo.mzMonthDays">
                                       <el-checkbox-button v-for="item in mzMonthDays" :label="item.value"
                                          :key="item.value">{{ item.label }}</el-checkbox-button>
                                    </el-checkbox-group>

                                 </el-form-item>

                                 <div id="smManrange">
                                    <label slot="label" :style="$common.labelStyle('备注')"
                                       v-html="$common.htmlLabel('备注')"></label>
                                    <div class="cmContent">
                                       <el-input type="textarea" v-model="sendDataInfo.remark">
                                       </el-input>
                                    </div>
                                 </div>
                              </el-form>
                           </div>

                           <!-- 促销条件块 -->
                           <div class="promotion-condition-section">

                              <div class="condition-title">促销条件</div>

                              <el-form :model="sendDataInfo" size="mini" inline label-width="150px"
                                 :show-message="false" :inline-message="false">
                                 <el-form-item label="促销类型" prop="mzConType"
                                    :rules="[{ required: true, message: '请选择促销类型', trigger: 'change' }]">
                                    <el-select v-model.number="sendDataInfo.mzConType" disabled placeholder="请选择促销类型"
                                       class="form_codition" @change="handlePromotionTypeChange">
                                       <el-option label="按金额" :value=1></el-option>
                                       <!-- <el-option label="按商品" :value=2></el-option> -->

                                    </el-select>
                                 </el-form-item>

                                 <el-form-item label="整单金额要求" prop="mzOrderMoney"
                                    :rules="[{ required: sendDataInfo.mzConType === '1', message: '请输入整单金额要求', trigger: 'blur' }]">
                                    <el-input v-model.number="sendDataInfo.mzOrderMoney" class="form_codition"
                                       placeholder="请输入整单金额要求" type="number" :min="0"
                                       :disabled="sendDataInfo.mzConType !== 1"></el-input>
                                 </el-form-item>


                                 <el-form-item label="是否叠加其他方案" prop="mzIsPileOther">
                                    <el-radio-group v-model="sendDataInfo.mzIsPileOther" size="mini">
                                       <!-- <el-radio-button :label="0">否</el-radio-button> -->
                                       <el-radio-button :label="1">是</el-radio-button>
                                    </el-radio-group>
                                 </el-form-item>
                                 <el-form-item label="选择叠加方案" prop="mzPileType" v-if="sendDataInfo.mzIsPileOther == 1"
                                    :rules="[{ required: sendDataInfo.mzIsPileOther == 1, message: '请选择叠加方案', trigger: 'blur' }]">
                                    <el-checkbox-group v-model="sendDataInfo.mzPileType">
                                       <el-checkbox-button v-for="item in mzPileType" :label="item.value"
                                          :key="item.value">{{ item.label }}</el-checkbox-button>
                                    </el-checkbox-group>
                                 </el-form-item>

                              </el-form>
                              <!-- 商品列表设置区域 -->
                              <!-- <div class="promotion-container">
                          
                                 <div class="promotion-section condition-section">
                                    <div class="section-header-simple">
                                       <div class="header-left-simple">
                                          <h3>{{ isExcludeGoodsMode ? '不参与商品列表' : '参与商品列表' }}</h3>
                                          <p class="section-desc-simple">
                                             {{ isExcludeGoodsMode ? '选择不参与促销活动的商品' : '选择能够参与促销活动的商品' }}
                                             <span class="list-count">已添加 {{ sendDataInfo.specialList.length }}
                                                个商品</span>
                                          </p>
                                       </div>
                                       <div class="header-actions-simple" v-if="dataActionBox.actionType != 2">
                                          <el-button type="primary" size="mini" @click="addDetails">
                                             <i class="el-icon-plus"></i> {{ isExcludeGoodsMode ?
                                                '添加不参与商品' : '添加参与商品' }}
                                          </el-button>

                                          <el-button type="danger" size="mini" @click="deleteDetails()">
                                             <i class="el-icon-delete"></i> 删除商品
                                          </el-button>
                                       </div>
                                    </div>

                                    <div class="section-content">
                                   
                                       <div class="goods-list-container">
                                          <div class="goods-table-wrapper">
                                             <el-table size="mini" ref="mxTableRef" id="mxTable"
                                                :data="sendDataInfo.specialList" height="400"
                                                @row-dblclick="openDateilsBox" @row-click="handleRowClick" border>
                                                <el-table-column label="选择" width="80" align="center">
                                                   <template slot-scope="scope">
                                                      <el-radio v-model="selectedDataIndex" :label="scope.$index" border
                                                         size="mini">
                                                         <i class="el-icon-thumb"></i>
                                                      </el-radio>
                                                   </template>
</el-table-column>

<el-table-column align="center" width="200" label="通用名称">
   <template slot-scope="scope">

                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].bgmName }}</span>
                                                   </template>
</el-table-column>

<el-table-column align="center" width="120" label="商品编码">
   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].bgmCode }}</span>
                                                   </template>
</el-table-column>

<el-table-column align="center" width="150" label="规格">
   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].spec }}</span>
                                                   </template>
</el-table-column>
<el-table-column align="center" width="120" label="统一零售价">
   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].retailPrice }}</span>
                                                   </template>
</el-table-column>



<el-table-column align="center" width="120" label="单品数量要求" v-if="sendDataInfo.mzConType === 2">
   <template slot-scope="scope">
                                                      <el-input v-if="dataActionBox.actionType != 2"
                                                         v-model="sendDataInfo.specialList[scope.$index].itemQtyRequired"
                                                         type="number" size="mini" placeholder="请输入数量" :min="0"
                                                         clearable>
                                                      </el-input>
                                                      <span v-else class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].itemQtyRequired
                                                      }}</span>
                                                   </template>
</el-table-column>

<el-table-column align="center" width="120" label="单品金额要求" v-if="sendDataInfo.mzConType === 2">
   <template slot-scope="scope">
                                                      <el-input v-if="dataActionBox.actionType != 2"
                                                         v-model="sendDataInfo.specialList[scope.$index].itemAmountRequired"
                                                         type="number" size="mini" placeholder="请输入金额" :min="0"
                                                         clearable>
                                                      </el-input>
                                                      <span v-else class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].itemAmountRequired
                                                      }}</span>
                                                   </template>
</el-table-column>

<el-table-column align="center" width="180" label="价格设置" v-if="sendDataInfo.mzConType === 2">
   <template slot-scope="scope">
                                                      <el-select v-if="dataActionBox.actionType != 2"
                                                         v-model.number="sendDataInfo.specialList[scope.$index].priceSettingType"
                                                         size="mini" placeholder="请选择价格设置">
                                                         <el-option label="价格不变" :value=1></el-option>
                                                         <el-option label="全部恢复原价" :value=2></el-option>
                                                         <el-option label="数量要求部分恢复原价" :value=3></el-option>
                                                      </el-select>
                                                      <span v-else class="ellipsis-cell">{{
                                                         getPriceSettingText(sendDataInfo.specialList[scope.$index].priceSettingType)
                                                      }}</span>
                                                   </template>
</el-table-column>
<el-table-column align="center" width="200" label="生产厂家">
   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].manufacturer }}</span>
                                                   </template>
</el-table-column>
<el-table-column align="center" width="120" label="产地">
   <template slot-scope="scope">
                                                      <span class="ellipsis-cell">{{
                                                         sendDataInfo.specialList[scope.$index].placeorigin }}</span>
                                                   </template>
</el-table-column>
</el-table>
</div>
</div>
</div>
</div>
</div> -->
                           </div>
                           <!-- 促销内容块 -->
                           <div class="promotion-content-section">
                              <div class="condition-title">促销内容设置</div>
                              <div class="section-content">
                                 <el-form :model="sendDataInfo" inline size="mini" label-width="150px"
                                    :show-message="false" :inline-message="false">
                                    <!-- 促销方式 -->
                                    <el-form-item label="促销方式">
                                       <el-select v-model.number="sendDataInfo.mzGiftType" placeholder="请选择促销方式"
                                          @change="handlePromotionMethodChange">
                                          <!-- <el-option label="赠品" :value=1></el-option> -->
                                          <!-- <el-option label="积分" :value=3></el-option> -->
                                          <el-option label="原品打折" :value=4></el-option>
                                          <el-option label="原品金额减免" :value=5></el-option>
                                          <!-- <el-option label="优惠最低价格品种金额" :value=6></el-option> -->
                                       </el-select>
                                    </el-form-item>
                                    <!-- 返现金额 -->
                                    <el-form-item label="返现金额">
                                       <el-input v-model.number="sendDataInfo.mzCashBack" type="number" size="mini"
                                          :min="0" controls-position="right" placeholder="请输入返现金额"
                                          :disabled="sendDataInfo.mzGiftType !== 5">
                                       </el-input>
                                    </el-form-item>
                                    <!-- 折扣 -->
                                    <el-form-item label="折扣">
                                       <el-input v-model.number="sendDataInfo.mzDiscount" type="number" size="mini"
                                          :min="0" controls-position="right" placeholder="请输入折扣"
                                          :disabled="sendDataInfo.mzGiftType !== 4">
                                       </el-input>
                                    </el-form-item>

                                 </el-form>
                              </div>

                              <!-- 赠品商品表格 -->
                              <div class="gift-goods-section" v-if="sendDataInfo.mzGiftType === 1">
                                 <div class="section-header-simple">
                                    <div class="header-left-simple">
                                       <h3>赠品商品列表</h3>
                                       <p class="section-desc-simple">
                                          选择作为赠品的商品
                                          <span class="list-count">已添加 {{ sendDataInfo.giftList ?
                                             sendDataInfo.giftList.length : 0 }} 个赠品</span>
                                       </p>
                                    </div>
                                    <div class="header-actions-simple" v-if="dataActionBox.actionType != 2">
                                       <el-button type="primary" size="mini" @click="addGiftDetails">
                                          <i class="el-icon-plus"></i> 添加赠品
                                       </el-button>
                                       <el-button type="danger" size="mini" @click="deleteGiftDetails()">
                                          <i class="el-icon-delete"></i> 删除赠品
                                       </el-button>
                                    </div>
                                 </div>

                                 <div class="section-content">
                                    <div class="goods-list-container">
                                       <div class="goods-table-wrapper">
                                          <el-table size="mini" ref="giftTableRef" id="giftTable"
                                             :data="sendDataInfo.giftList || []" height="300"
                                             @row-dblclick="openGiftDetailsBox" border>
                                             <el-table-column label="选择" width="80" align="center">
                                                <template slot-scope="scope">
                                                   <el-radio v-model="selectedGiftIndex" :label="scope.$index" border
                                                      size="mini">
                                                      <i class="el-icon-thumb"></i>
                                                   </el-radio>
                                                </template>
                                             </el-table-column>
                                             <!-- 商品名称 -->
                                             <el-table-column align="center" width="200" label="通用名称">
                                                <template slot-scope="scope">
                                                   <el-input :ref="'giftBgmName'" v-if="dataActionBox.actionType != 2"
                                                      v-model="sendDataInfo.giftList[scope.$index].bgmName"
                                                      @keyup.enter.native="openSearch('8820873997127710', scope.$index, 'giftBgmName', 'bgmId,bgmName')"
                                                      clearable placeholder="请选择赠品商品">
                                                      <el-button
                                                         @click="openSearch('8820873997127710', scope.$index, 'giftBgmName', 'bgmId,bgmName')"
                                                         slot="append" icon="el-icon-search"></el-button>
                                                   </el-input>
                                                   <span v-else class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].bgmName }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 商品编码 -->
                                             <el-table-column align="center" width="120" label="商品编码">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].bgmCode }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 规格 -->
                                             <el-table-column align="center" width="150" label="规格">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].spec }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 统一零售价 -->
                                             <el-table-column align="center" width="120" label="统一零售价">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].retailPrice }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 赠送数量 -->
                                             <!-- <el-table-column align="center" width="120" label="赠送数量">
                                                <template slot-scope="scope">
                                                   <el-input v-if="dataActionBox.actionType != 2"
                                                      v-model="sendDataInfo.giftList[scope.$index].giftQty"
                                                      type="number" size="mini" placeholder="请输入数量" :min="1" clearable>
                                                   </el-input>
                                                   <span v-else class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].giftQty }}</span>
                                                </template>
                                             </el-table-column> -->

                                             <!-- 生产厂家 -->
                                             <el-table-column align="center" width="200" label="生产厂家">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].manufacturer }}</span>
                                                </template>
                                             </el-table-column>

                                             <!-- 产地 -->
                                             <el-table-column align="center" width="120" label="产地">
                                                <template slot-scope="scope">
                                                   <span class="ellipsis-cell">{{
                                                      sendDataInfo.giftList[scope.$index].placeorigin }}</span>
                                                </template>
                                             </el-table-column>
                                          </el-table>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>



                        <!-- 右侧固定区域 -->
                        <!-- <div class="right-section">
                           <div class="right-content">
                           
                              <div class="store-section">
                                 <div class="section-header">
                                    <div class="header-content">
                                       <i class="el-icon-office-building"></i>
                                       <span>绑定门店</span>
                                    </div>
                                    <div class="selection-count">
                                       {{ selectedStores.length }}/{{ storeList.length }}
                                    </div>
                                 </div>
                                 <div class="table-container">
                                    <el-table :data="storeList" size="mini" height="320"
                                       @selection-change="handleStoreSelectionChange" ref="storeTable"
                                       class="elegant-table">
                                       <el-table-column type="selection" width="45"></el-table-column>
                                       <el-table-column prop="storeName" label="门店名称" width="120">
                                          <template slot-scope="scope">
                                             <span class="store-name-text">{{ scope.row.storeName || scope.row.name
                                             }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeType" label="门店类型" width="100">
                                          <template slot-scope="scope">
                                             <span class="store-type-text">{{ scope.row.storeType || scope.row.type ||
                                                '未知' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="phone" label="联系电话" width="120">
                                          <template slot-scope="scope">
                                             <span class="store-phone-text">{{ scope.row.storePhone || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeAddress" label="门店地址" width="150">
                                          <template slot-scope="scope">
                                             <span class="store-address-text">{{ scope.row.storeAddress ||
                                                scope.row.address || scope.row.location || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                       <el-table-column prop="storeArea" label="门店区域" width="100">
                                          <template slot-scope="scope">
                                             <span class="store-area-text">{{ scope.row.storeArea || scope.row.area ||
                                                scope.row.region || '暂无' }}</span>
                                          </template>
                                       </el-table-column>
                                    </el-table>
                                 </div>
                              </div>
                           </div>
                        </div> -->
                     </div>
                  </div>
               </template>
            </v-tabs>
         </el-card>
      </div>
      <div class="foot">
         <div>
            <el-button @click="drawerCancel">取 消</el-button>
            <el-button type="primary" @click="sendDataAction()" v-if="!checkDisabled">保 存</el-button>
         </div>
      </div>
      <!-- 检索阶梯 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body="true" :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 通用名称列表 -->
      <el-dialog :title="actionData.cate === 0 ? '添加通用商品明细' : '编辑通用商品明细'" v-if="shopListVisible"
         :visible.sync="shopListVisible" :modal-append-to-body="true" :append-to-body="true" width="75%" center>
         <div class="store-modal-content">
            <!-- 搜索条件 -->
            <div class="search-container" style="margin-bottom: 20px;">
               <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                  <el-form-item label="商品名称">
                     <el-input v-model="searchForm.bgmName" placeholder="请输入商品名称" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="商品分类">
                     <el-select v-model="searchForm.bgmType" placeholder="请选择商品分类" clearable>
                        <el-option v-for="item in bgmTypeList" :key="item.btId" :label="item.btName"
                           :value="item.btId"></el-option>
                     </el-select>
                  </el-form-item>
                  <el-form-item label="生产商">
                     <el-input v-model="searchForm.manufacturer" placeholder="请输入生产商" clearable></el-input>
                  </el-form-item>
                  <el-form-item>
                     <el-button type="primary" @click="searchCommonNames">查询</el-button>

                     <el-button type="success" @click="selectAllCommonNames">选择全部</el-button>
                  </el-form-item>
               </el-form>
            </div>

            <!-- 表格 -->
            <el-table :data="commonNamesList" border style="width: 100%" height="400"
               @selection-change="handleCommonNameSelectionChange" ref="commonNamesTable">
               <el-table-column type="selection" width="55">
               </el-table-column>
               <el-table-column prop="bgmCode" label="商品编码" width="160">
               </el-table-column>
               <el-table-column prop="bgmName" label="通用名称" width="180">
               </el-table-column>
               <el-table-column prop="spec" label="规格" width="250">
               </el-table-column>
               <el-table-column prop="manufacturer" label="生产商" width="220">
               </el-table-column>
               <el-table-column prop="placeorigin" label="产地" width="200">
               </el-table-column>
               <el-table-column prop="retailPrice" label="统一零售价" width="120">
               </el-table-column>

            </el-table>

            <!-- 分页 -->
            <div class="pagination-container" style="margin-top: 20px; text-align: right;">
               <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page="currentPage" :page-sizes="[30, 50, 100, 200]" :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper" :total="total">
               </el-pagination>
            </div>
         </div>
         <div slot="footer" class="dialog-footer">
            <el-button @click="shopListVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitCommonNameSelection">确 定</el-button>
         </div>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";

export default {
   props: ["actionData"],
   name: "yhqGiftsAction",
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      return {
         dataActionBox: {
            actionType: 0, // 0新增，1修改
         },
         checkDisabled: false,

         sendDataInfo: {
            yhqName: '',//  优惠券名称
            limitDay: '',// 使用期限(天)
            yhqDesc: "", // 优惠券描述
            startDate: new Date().getTime(), // 开始日期，默认为当前日期
            endDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).getTime(), // 结束日期，默认为一周后
            dayStartTime: "00:00:00", // 开始时间
            dayEndTime: "23:59:59", // 结束时间
            memReq: 2, // 会员要求 1不限 2会员卡类型 3会员积分
            remark: '',
            specialList: [], // 明细列表
            giftList: [], // 赠品列表
            roundType: 0, // 周期类型
            roundDay: "", // 周期
            conType: 1, // 促销类型，1表示单品特价
            mzConType: 1, // 促销条件类型
            mzOrderMoney: "", // 整单金额要求
            mzConBgmNum: "", // 条件商品数量要求
            mzConBgmMoney: "", // 条件商品金额要求
            mzBgmTypeNum: "", // 品种数量要求
            mzIsPileOther: 1, // 特价与打折是否参与 
            mzPileType: ['1'], // 是否叠加其他促销
            mzGiftType: 4, // 促销方式，默认为赠品 
            mzIsRepeat: 0, // 是否允许重复赠送 
            mzCashBack: "", // 返现金额
            mzDiscount: "", // 折扣
            mzAddPoint: "", // 赠送积分
            mzReducePoint: "", // 冲减积分
            mzGiftNum: "", // 赠送品种数量
            planType: 4, // 促销方案类型 优惠券
            mzWeekDays: ['1', '2', '3', '4', '5', '6', '7'], // 促销周期
            mzMonthDays: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'], // 促销日期
         },
         mzPileType: [
            { label: "会员价", value: '1' },
            { label: "特价", value: '2' },
            { label: "整单优惠", value: '3' },
            { label: "赠品", value: '4' },
            { label: "赠送优惠券", value: '5' },
            { label: "赠送积分", value: '6' },
            { label: "原品优惠", value: '7' },
            { label: "优惠价格最低品种", value: '8' },
            { label: "超量促销", value: '9' },
            // { label: "优惠券", value: '10' },
         ],
         mzWeekDays: [
            { label: "周一", value: '1' },
            { label: "周二", value: '2' },
            { label: "周三", value: '3' },
            { label: "周四", value: '4' },
            { label: "周五", value: '5' },
            { label: "周六", value: '6' },
            { label: "周日", value: '7' },
         ],
         mzMonthDays: [
            { label: "1日", value: '1' },
            { label: "2日", value: '2' },
            { label: "3日", value: '3' },
            { label: "4日", value: '4' },
            { label: "5日", value: '5' },
            { label: "6日", value: '6' },
            { label: "7日", value: '7' },
            { label: "8日", value: '8' },
            { label: "9日", value: '9' },
            { label: "10日", value: '10' },
            { label: "11日", value: '11' },
            { label: "12日", value: '12' },
            { label: "13日", value: '13' },
            { label: "14日", value: '14' },
            { label: "15日", value: '15' },
            { label: "16日", value: '16' },
            { label: "17日", value: '17' },
            { label: "18日", value: '18' },
            { label: "19日", value: '19' },
            { label: "20日", value: '20' },
            { label: "21日", value: '21' },
            { label: "22日", value: '22' },
            { label: "23日", value: '23' },
            { label: "24日", value: '24' },
            { label: "25日", value: '25' },
            { label: "26日", value: '26' },
            { label: "27日", value: '27' },
            { label: "28日", value: '28' },
            { label: "29日", value: '29' },
            { label: "30日", value: '30' },
            { label: "31日", value: '31' },
         ],
         formDataList: [],
         showTabs: "",
         DialogVisible: false, //判断是否打开检索阶梯弹框
         seTitle: "", //检索阶梯的名称
         seType: "", //检索阶梯查询条件字段
         seWidth: "", //检索阶梯弹框的宽度
         sField: "", //赋值字段
         parentSearchData: {}, //检索阶梯补充的查询列表的查询条件
         selectedDataIndex: 0, // 选中的明细索引
         selectedGiftIndex: 0, // 选中的赠品索引
         detaislDataInfo: {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            price: "",
            barcode: "",
            placeorigin: "",
            bgiBrand: "", // 品系名称
            itemQtyRequired: "", // 单品数量要求
            itemAmountRequired: "", // 单品金额要求
            priceSettingType: 1, // 价格设置类型，默认为价格不变 
         },
         giftDetailsInfo: {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            barcode: "",
            placeorigin: "",
            giftQty: 1, // 赠送数量，默认为1
         },
         seIndex: 0, // 当前操作的明细索引
         // 会员卡类型相关数据
         cardTypeList: [], // 会员卡类型列表
         selectedCardTypes: [], // 选中的会员卡类型
         selectedCardTypeIds: [], // 选中的会员卡类型ID数组（用于复选框）

         // 门店相关数据
         storeList: [], // 门店列表
         selectedStores: [], // 选中的门店

         // 会员相关数据
         memberList: [], // 会员列表
         selectedMembers: [], // 选中的会员
         selectedMemberIds: [], // 选中的会员ID数组（用于复选框）

         // 促销条件数据
         mzConType: '按商品', // 默认促销类型
         // -----------------通用名称列表-----------------
         bgmTypeList: [],
         searchForm: {
            bgmName: '',
            manufacturer: '',
            btId: ''
         },
         shopListVisible: false,
         commonNamesList: [],
         currentPage: 1,
         pageSize: 30,
         total: 0,
         selectedCommonNames: [],
         allCommonNamesList: [],
         selectedAllCommonNames: false,
         allCommonNamesIds: []
      }
   },
   computed: {
      // 格式化开始日期显示
      formattedStartDate() {
         if (!this.sendDataInfo.startDate) return '未选择';
         return this.$moment(this.sendDataInfo.startDate).format('YYYY-MM-DD');
      },
      // 格式化结束日期显示
      formattedEndDate() {
         if (!this.sendDataInfo.endDate) return '未选择';
         return this.$moment(this.sendDataInfo.endDate).format('YYYY-MM-DD');
      },
      // 计算促销天数
      promotionDays() {
         if (!this.sendDataInfo.startDate || !this.sendDataInfo.endDate) return 0;
         const start = new Date(this.sendDataInfo.startDate);
         const end = new Date(this.sendDataInfo.endDate);
         const diffTime = Math.abs(end - start);
         const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
         return diffDays + 1; // 包含开始和结束日期
      },

      // 判断是否为不参与商品模式
      isExcludeGoodsMode() {
         return this.sendDataInfo.mzConType === 1

      },

      // 全选状态
      isAllSelected: {
         get() {
            return this.selectedCardTypeIds.length === this.cardTypeList.length && this.cardTypeList.length > 0;
         },
         set(value) {
            if (value) {
               this.selectedCardTypeIds = this.cardTypeList.map(item => item.capId);
               this.selectedCardTypes = [...this.cardTypeList];
            } else {
               this.selectedCardTypeIds = [];
               this.selectedCardTypes = [];
            }
         }
      },

      // 会员全选状态
      isAllMembersSelected: {
         get() {
            return this.selectedMemberIds.length === this.memberList.length && this.memberList.length > 0;
         },
         set(value) {
            if (value) {
               this.selectedMemberIds = this.memberList.map(item => item.memberId);
               this.selectedMembers = [...this.memberList];
            } else {
               this.selectedMemberIds = [];
               this.selectedMembers = [];
            }
         }
      },


   },
   watch: {
      'sendDataInfo.mzIsPileOther': {
         handler(newVal) {
            if (newVal == 0) {
               // 当特价与打折参与设置为"否"时，清空叠加其他促销的选择
               this.sendDataInfo.mzPileType = [];
            }
         },
         immediate: true
      },
      'shopListVisible': {
         handler(newVal) {
            if (!newVal) {
               // 当对话框关闭时，清空选中状态
               this.selectedCommonNames = [];
               this.selectedAllCommonNames = false;
               this.allCommonNamesList = [];
               this.allCommonNamesIds = [];
            }
         }
      }
   },
   methods: {

      async getTypeList() {
         let responseData = await this.$http.getTypeList({
            businessId: "",
            creater: 0,
            ormId: 0,
            page: 1,
            rows: 50,
            start: "",
            end: "",
            btName: ""
         })
         if (responseData.status == 200) {
            this.bgmTypeList = responseData.result.list
         }
      },
      async openBox() {

         if (this.actionData.cate == 0) {
            this.showTabs = "新增"
            this.formDataList = [
               {
                  jciName: "新增",
                  jurconfigform: [],
               },
            ]
         } else {
            // 回显数据
            console.log(this.actionData.oldData, 'this.actionData.oldData');
            this.checkDisabled = this.actionData?.checkDisabled ? true : false
            if (this.actionData.oldData) {
               for (let key in this.actionData.oldData) {
                  // 特殊处理周期类型
                  if (key === "roundWeek") {
                     const roundWeek = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzWeekDays = roundWeek;
                  } else if (key === "roundDay") {
                     const roundDay = this.actionData.oldData[key].split(',');
                     this.sendDataInfo.mzMonthDays = roundDay;
                  } else if (key === "mzPileType") {
                     this.sendDataInfo.mzPileType = this.actionData.oldData[key].split(',');
                  } else if (key === "dayStartTime" || key === "dayEndTime") {
                     // 特殊处理每日时间字段，将秒数转换为时间字符串
                     const seconds = this.actionData.oldData[key];
                     if (seconds !== null && seconds !== undefined && seconds !== "") {
                        const hours = Math.floor(seconds / 3600);
                        const minutes = Math.floor((seconds % 3600) / 60);
                        const secs = seconds % 60;
                        const timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
                        this.$set(this.sendDataInfo, key, timeString);
                     } else {
                        this.$set(this.sendDataInfo, key, "");
                     }
                  } else {
                     this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
                  }
               }



               // 回显赠品数据
               if (this.actionData.oldData.conBgmList && this.actionData.oldData.conBgmList.length > 0) {
                  this.sendDataInfo.specialList = this.actionData.oldData.conBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     itemQtyRequired: item.num || "",
                     itemAmountRequired: item.money || "",
                     priceSettingType: item.priceSet || 1,

                  }));
                  console.log(this.sendDataInfo.specialList, 'this.sendDataInfo.specialList');

               }

               // 回显赠品赠送列表
               if (this.actionData.oldData.giftBgmList && this.actionData.oldData.giftBgmList.length > 0) {
                  this.sendDataInfo.giftList = this.actionData.oldData.giftBgmList.map(item => ({
                     bgmId: item.bgmId || "",
                     bgmName: item.bgmName || "",
                     bgmCode: item.bgmCode || "",
                     bgmSpec: item.bgmSpec || "",
                     spec: item.spec || "",
                     manufacturer: item.manufacturer || "",
                     barcode: item.barcode || "",
                     placeorigin: item.placeorigin || "",
                     retailPrice: item.retailPrice || "",
                     price: item.price || "",
                  }));
               }

               // 回显会员卡类型和门店选择
               this.$nextTick(async () => {
                  // 回显会员卡类型选择
                  if (this.actionData.oldData.mcTypeList && this.actionData.oldData.mcTypeList.length > 0) {
                     await this.loadCardTypeData();
                     // 获取所有需要选中的卡类型ID
                     const selectedIds = this.actionData.oldData.mcTypeList.map(item => item.capId);
                     // 设置选中状态
                     this.selectedCardTypeIds = selectedIds;
                     // 设置选中的对象数组
                     this.selectedCardTypes = this.cardTypeList.filter(item => selectedIds.includes(item.capId));
                     console.log('已选中会员卡类型:', this.selectedCardTypes.length);
                  }

                  // 回显会员选择
                  // if (this.actionData.oldData.selectedMembers && this.actionData.oldData.selectedMembers.length > 0) {
                  //    const selectedMemberIds = this.actionData.oldData.selectedMembers
                  //    // 设置复选框选中的ID
                  //    this.selectedMemberIds = selectedMemberIds
                  //    // 设置选中的对象数组
                  //    this.selectedMembers = this.memberList.filter(item => selectedMemberIds.includes(item.memberId))
                  // }

                  // 回显门店选择
                  if (this.actionData.oldData.storeList && this.actionData.oldData.storeList.length > 0) {
                     await this.loadStoreData();
                     const selectedStoreIds = this.actionData.oldData.storeList;
                     console.log(this.storeList, 'this.storeList');

                     this.storeList.forEach(item => {
                        const itemId = item.id || item.storeId;
                        // 检查是否存在匹配的门店ID
                        const isSelected = selectedStoreIds.some(store =>

                           (store.id === itemId || store.storeId === itemId)
                        );
                        if (isSelected) {
                           this.$refs.storeTable.toggleRowSelection(item, true);
                        }
                     });
                  }
               })
            }

            this.formDataList = [
               {
                  jciName: "编辑",
                  jurconfigform: [],
               },
            ]
            this.showTabs = "编辑"
         }

         this.dataActionBox.actionType = this.actionData.cate
         this.init()

      },
      // 初始化数据
      init() {
         // 只有在新增模式下才清空明细数据
         if (this.dataActionBox.actionType == 0) {
            this.sendDataInfo.specialList = [];
            this.sendDataInfo.giftList = [];
            this.sendDataInfo.roundDay = "";
            this.memDayIds = [];
            // 设置默认日期
            this.sendDataInfo.startDate = new Date().getTime(); // 当前日期
            this.sendDataInfo.endDate = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).getTime(); // 一周后
         }

         // 初始化明细默认数据
         this.detaislDataInfo = {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            price: "",
            barcode: "",
            placeorigin: "",
            bgiBrand: "", // 品系名称
            itemQtyRequired: "", // 单品数量要求
            itemAmountRequired: "", // 单品金额要求
            priceSettingType: 1, // 价格设置类型，默认为价格不变
            mzIsPileOther: 0, // 特价与打折是否参与
         };

         // 初始化赠品默认数据
         this.giftDetailsInfo = {
            bgmId: "",
            bgmName: "",
            bgmCode: "",
            bgmSpec: "",
            spec: "",
            manufacturer: "",
            retailPrice: "",
            barcode: "",
            placeorigin: "",
            giftQty: 1, // 赠送数量，默认为1
         };

         // 加载会员卡类型、会员和门店数据
         this.loadCardTypeData();
         // this.loadMemberData();
         this.loadStoreData();
      },
      // 新增明细
      addDetails() {
         this.searchCommonNames()
         this.shopListVisible = true

      },
      // 删除明细
      deleteDetails() {
         if (this.sendDataInfo.specialList.length > 0) {
            this.sendDataInfo.specialList.splice(this.selectedDataIndex, 1);
            this.selectedDataIndex = 0;
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.specialList[index + 1] != undefined) {
               // 根据促销类型选择焦点字段
               const focusField = this.sendDataInfo.conType == 2 ? "bgiBrand" : "bgmName";
               if (this.$refs[focusField] && this.$refs[focusField][index + 1]) {
                  this.$refs[focusField][index + 1].focus();
               }
               this.selectedDataIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  if (refsElTable) {
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.specialList[this.selectedDataIndex]
                     );
                  }
               });
               return;
            }
            this.addDetails();
            return;
         }
         // 根据促销类型选择焦点字段
         const focusField = this.sendDataInfo.conType == 2 ? "bgiBrand" : field;
         if (this.$refs[focusField] && this.$refs[focusField][index]) {
            this.$refs[focusField][index].focus();
         }
      },
      // 双击明细行
      openDateilsBox(row, column, event) {
         this.editDateilsIndex = row.index;
         this.specialList = JSON.parse(JSON.stringify(row));
      },
      handleRowClick(row) {
         console.log(row, 'row');
         this.selectedDataIndex = this.sendDataInfo.specialList.findIndex(item => item.bgmId === row.bgmId)
      },
      //获取检索阶梯弹框宽度
      getSeWidth(e) {
         this.seWidth = e + "%"
      },
      //获取检索阶梯弹框名称
      getSearchName(e) {
         this.seTitle = e
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         this.seId = sId //检索阶梯Id
         this.sField = sField //赋值字段
         this.DialogVisible = true //判断是否打开弹框
         this.seType = type
         this.seIndex = index // 设置当前操作的明细索引
         console.log('openSearch - seIndex:', this.seIndex, 'seType:', this.seType);
      },
      //检索阶梯返回的数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false
            console.log('changeInputModel - seType:', this.seType, 'seIndex:', this.seIndex, 'val:', val);

            if (this.seType == "bgmName") {
               // 处理商品搜索返回的数据
               if (this.seIndex !== undefined) {
                  // 第一个表单
                  console.log('处理第一个表单，索引:', this.seIndex);
                  for (let fkey in this.sendDataInfo.specialList[this.seIndex]) {
                     for (let vkey in val) {
                        if (fkey == vkey) {
                           this.$set(
                              this.sendDataInfo.specialList[this.seIndex],
                              fkey,
                              val[vkey]
                           );
                        }
                     }
                  }
                  // 设置商品相关信息
                  this.sendDataInfo.specialList[this.seIndex].bgmId = val.bgmId;
                  this.sendDataInfo.specialList[this.seIndex].bgmName = val.bgmName;
                  this.sendDataInfo.specialList[this.seIndex].bgmCode = val.bgmCode;
                  this.sendDataInfo.specialList[this.seIndex].bgmSpec = val.bgmSpec;
                  this.sendDataInfo.specialList[this.seIndex].spec = val.spec;
                  this.sendDataInfo.specialList[this.seIndex].manufacturer = val.manufacturer;
                  this.sendDataInfo.specialList[this.seIndex].retailPrice = val.retailPrice;
                  this.sendDataInfo.specialList[this.seIndex].price = val.price;
                  this.sendDataInfo.specialList[this.seIndex].barcode = val.barcode;
                  this.sendDataInfo.specialList[this.seIndex].placeorigin = val.placeorigin;
                  this.sendDataInfo.specialList[this.seIndex].itemQtyRequired = "";
                  this.sendDataInfo.specialList[this.seIndex].itemAmountRequired = "";
                  this.sendDataInfo.specialList[this.seIndex].priceSettingType = 1;
                  this.sendDataInfo.specialList[this.seIndex].mzIsPileOther = 0;
               }
            } else if (this.seType == "giftBgmName") {
               // 处理赠品商品搜索返回的数据
               if (this.seIndex !== undefined) {
                  for (let fkey in this.sendDataInfo.giftList[this.seIndex]) {
                     for (let vkey in val) {
                        if (fkey == vkey) {
                           this.$set(
                              this.sendDataInfo.giftList[this.seIndex],
                              fkey,
                              val[vkey]
                           );
                        }
                     }
                  }
                  // 设置赠品相关信息
                  this.sendDataInfo.giftList[this.seIndex].bgmId = val.bgmId;
                  this.sendDataInfo.giftList[this.seIndex].bgmName = val.bgmName;
                  this.sendDataInfo.giftList[this.seIndex].bgmCode = val.bgmCode;
                  this.sendDataInfo.giftList[this.seIndex].bgmSpec = val.bgmSpec;
                  this.sendDataInfo.giftList[this.seIndex].spec = val.spec;
                  this.sendDataInfo.giftList[this.seIndex].manufacturer = val.manufacturer;
                  this.sendDataInfo.giftList[this.seIndex].retailPrice = val.retailPrice;
                  this.sendDataInfo.giftList[this.seIndex].barcode = val.barcode;
                  this.sendDataInfo.giftList[this.seIndex].placeorigin = val.placeorigin;
                  this.sendDataInfo.giftList[this.seIndex].giftQty = 1; // 默认赠送数量为1
               }
            } else {
               this.paramValue(val) //赋值字段，赋值
            }
         }
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",")
         arr.forEach((item) => {
            this.sendDataInfo[item] = val[item]
         })
      },
      //关闭提取、检索阶梯弹框关闭 创建键盘事件
      closeChild() {
         addEventListener("keyup", this.keyUp) //创建监听键盘事件
      },
      async sendDataAction() {

         // 表单验证
         this.$refs.sendDataInfo.validate(async (valid) => {
            if (valid) {
               // 验证开始日期和结束日期
               if (this.sendDataInfo.startDate && this.sendDataInfo.endDate) {
                  if (this.sendDataInfo.endDate < this.sendDataInfo.startDate) {
                     this.$message({
                        message: "结束日期不能小于开始日期",
                        type: "error",
                     });
                     return false;
                  }
                  // 处理开始日期和结束日期，去掉时分秒
                  const startDate = new Date(this.sendDataInfo.startDate);
                  const endDate = new Date(this.sendDataInfo.endDate);

                  // 设置时间为当天的 00:00:00
                  startDate.setHours(0, 0, 0, 0);
                  endDate.setHours(0, 0, 0, 0);

                  // 更新时间戳
                  this.sendDataInfo.startDate = startDate.getTime();
                  this.sendDataInfo.endDate = endDate.getTime();
               }


               // 验证促销方式相关
               switch (this.sendDataInfo.mzGiftType) {
                  case '1':
                     // 如果选择了赠品促销方式，验证是否添加了赠品
                     if (!this.sendDataInfo.giftList || this.sendDataInfo.giftList.length === 0) {
                        this.$message({
                           message: "请添加至少一个赠品商品",
                           type: "error",
                        });
                        return false;
                     }

                     // 验证赠品数据完整性
                     for (let i = 0; i < this.sendDataInfo.giftList.length; i++) {
                        const gift = this.sendDataInfo.giftList[i];
                        if (!gift.bgmId || !gift.bgmName) {
                           this.$message({
                              message: `赠品第${i + 1}行商品信息不完整`,
                              type: "error",
                           });
                           return false;
                        }

                        if (!gift.giftQty || gift.giftQty < 1) {
                           this.$message({
                              message: `赠品第${i + 1}行赠送数量必须大于0`,
                              type: "error",
                           });
                           return false;
                        }
                     }

                     // 验证冲减积分和赠送品种数量
                     if (this.sendDataInfo.mzReducePoint === "") {
                        this.$message({
                           message: "请输入冲减积分",
                           type: "error",
                        });
                        return false;
                     }

                     if (this.sendDataInfo.mzGiftNum === "") {
                        this.$message({
                           message: "请输入赠送品种数量",
                           type: "error",
                        });
                        return false;
                     }
                     break;

                  case '2':
                     // 验证冲减积分和赠送品种数量
                     if (this.sendDataInfo.mzReducePoint === "") {
                        this.$message({
                           message: "请输入冲减积分",
                           type: "error",
                        });
                        return false;
                     }

                     if (this.sendDataInfo.mzGiftNum === "") {
                        this.$message({
                           message: "请输入赠送品种数量",
                           type: "error",
                        });
                        return false;
                     }
                     break;

                  case '5':
                     // 验证返现金额
                     if (this.sendDataInfo.mzCashBack === "") {
                        this.$message({
                           message: "请输入返现金额",
                           type: "error",
                        });
                        return false;
                     }
                     break;

                  case '4':
                     // 验证折扣
                     if (this.sendDataInfo.mzDiscount === "") {
                        this.$message({
                           message: "请输入折扣",
                           type: "error",
                        });
                        return false;
                     }
                     break;

                  case '3':
                     // 验证赠送积分
                     if (this.sendDataInfo.mzAddPoint === "") {
                        this.$message({
                           message: "请输入赠送积分",
                           type: "error",
                        });
                        return false;
                     }
                     break;
               }

               // 验证每日开始时间和每日结束时间
               if (this.sendDataInfo.dayStartTime && this.sendDataInfo.dayEndTime) {
                  // 直接处理时间字符串格式 HH:mm:ss
                  const startParts = this.sendDataInfo.dayStartTime.split(':');
                  const endParts = this.sendDataInfo.dayEndTime.split(':');

                  const startHours = parseInt(startParts[0]) || 0;
                  const startMinutes = parseInt(startParts[1]) || 0;
                  const startSeconds = parseInt(startParts[2]) || 0;

                  const endHours = parseInt(endParts[0]) || 0;
                  const endMinutes = parseInt(endParts[1]) || 0;
                  const endSeconds = parseInt(endParts[2]) || 0;

                  // 转换为秒数进行比较
                  const startTotalSeconds = startHours * 3600 + startMinutes * 60 + startSeconds;
                  const endTotalSeconds = endHours * 3600 + endMinutes * 60 + endSeconds;

                  if (endTotalSeconds <= startTotalSeconds) {
                     this.$message({
                        message: "每日结束时间不能小于或等于每日开始时间",
                        type: "error",
                     });
                     return false;
                  }
               }

               // 验证积分要求
               if (this.sendDataInfo.memReq == 3 && (!this.sendDataInfo.memReqPoint )) {
                  this.$message({
                     message: "请填写积分要求",
                     type: "error",
                  });
                  return false;
               }

               // 验证会员卡类型选择
               if (this.sendDataInfo.memReq == 2 && this.selectedCardTypes.length === 0) {
                  this.$message({
                     message: "请选择至少一个会员卡类型",
                     type: "error",
                  });
                  return false;
               }



               // 验证促销条件
               if (this.sendDataInfo.mzConType === 1 && !this.sendDataInfo.mzOrderMoney) {
                  this.$message({
                     message: "请输入整单金额要求",
                     type: "error",
                  });
                  return false;
               }

               // 按商品促销类型需要验证条件商品数量
               if (this.sendDataInfo.mzConType === 2 && !this.sendDataInfo.mzConBgmNum) {
                  this.$message({
                     message: "请输入条件商品数量要求",
                     type: "error",
                  });
                  return false;
               }

               // 按商品分类促销类型需要验证条件商品数量
               if (this.sendDataInfo.mzConType === 2 && !this.sendDataInfo.mzConBgmNum) {
                  this.$message({
                     message: "请输入条件商品数量要求",
                     type: "error",
                  });
                  return false;
               }


               // 按商品促销类型需要验证商品列表
               if (this.sendDataInfo.mzConType === 2 && this.sendDataInfo.specialList.length === 0) {
                  this.$message({
                     message: "请添加参与促销的商品",
                     type: "error",
                  });
                  return false;
               }

               if (Number(this.sendDataInfo.mzBgmTypeNum) < this.sendDataInfo.specialList.length && Number(this.sendDataInfo.mzBgmTypeNum) > 0) {
                  this.$message({
                     message: "赠品数量不能小于参与促销的商品数量",
                     type: "error",
                  });
                  return false;
               }

               // ------------------处理参数------------------
               //会员要求：会员卡类型
               if (this.sendDataInfo.memReq == 2) {
                  this.sendDataInfo.mcTypeList = this.selectedCardTypes.map(item => {
                     return item.capId
                  })
               }


               if (this.sendDataInfo.mzConType == 1) {
                  // 不可参与商品
                  this.sendDataInfo.banBgmList = this.sendDataInfo.specialList.map(item => item.bgmId)
               } else if (this.sendDataInfo.mzConType == 2) {
                  this.sendDataInfo.conBgmList = this.sendDataInfo.specialList.map(item => {
                     return {
                        bgmId: item.bgmId,
                        money: Number(item.itemAmountRequired),
                        num: Number(item.itemQtyRequired),
                        priceSet: Number(item.priceSettingType),
                     }
                  })
               }

               if (this.sendDataInfo.mzGiftType == 1) {
                  this.sendDataInfo.giftBgmList = this.sendDataInfo.giftList.map(item => {
                     return item.bgmId
                  })
               } else if (this.sendDataInfo.mzGiftType == 2) {
                  // 赠送优惠券列表
                  this.sendDataInfo.giftYhqList = []
               }




               console.log(this.sendDataInfo, "this.sendDataInfo");

               let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))

               // 日期周期（数字逗号隔开）
               sendData.roundDay = this.sendDataInfo.mzMonthDays ? this.sendDataInfo.mzMonthDays.join(',') : ''
               // 星期周期（数字逗号隔开）
               sendData.roundWeek = this.sendDataInfo.mzWeekDays ? this.sendDataInfo.mzWeekDays.join(',') : ''
               // 是否叠加其他促销（数字逗号隔开）

               sendData.mzPileType = this.sendDataInfo.mzPileType ? this.sendDataInfo.mzPileType.join(',') : ''
               console.log(this.selectedStores, 'this.selectedStores');

               // 门店id列表
               sendData.storeIdList = this.selectedStores && this.selectedStores.length > 0 ?
                  this.selectedStores.map(item => item.id || item.storeId) : []



               // 处理每日开始时间和每日结束时间，转换为秒数
               if (sendData.dayStartTime) {
                  // 将时间字符串转换为秒数
                  const timeParts = sendData.dayStartTime.split(':');
                  const hours = parseInt(timeParts[0]) || 0;
                  const minutes = parseInt(timeParts[1]) || 0;
                  const seconds = parseInt(timeParts[2]) || 0;
                  sendData.dayStartTime = hours * 3600 + minutes * 60 + seconds;
               }

               if (sendData.dayEndTime) {
                  // 将时间字符串转换为秒数
                  const timeParts = sendData.dayEndTime.split(':');
                  const hours = parseInt(timeParts[0]) || 0;
                  const minutes = parseInt(timeParts[1]) || 0;
                  const seconds = parseInt(timeParts[2]) || 0;
                  sendData.dayEndTime = hours * 3600 + minutes * 60 + seconds;
               }


               let param = {}
               param.yhqName = this.sendDataInfo.yhqName
               param.yhqDesc = this.sendDataInfo.yhqDesc
               param.limitDay = this.sendDataInfo.limitDay
               param.remark = this.sendDataInfo.remark
               sendData.planName = this.sendDataInfo.yhqName
               sendData.planDesc = this.sendDataInfo.yhqDesc
               sendData.remark = this.sendDataInfo.remark
               param.planInfo = sendData
               try {
                  let responseData
                  // 如果是新增
                  if (this.dataActionBox.actionType == 0) {
                     responseData = await this.$http.deraYhqAddYhq(param)
                  }
                  // 如果是编辑
                  else if (this.dataActionBox.actionType == 1) {
                     param.yhqId = sendData.yhqId
                     responseData = await this.$http.deraYhqUpdateYhq(param)
                  }

                  if (responseData.status == 200) {
                     this.$message({
                        message:
                           this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                        type: "success",
                     })
                     this.$emit("drawerCancel", false)
                     this.$emit("toDetail", responseData.result)
                  } else {
                     this.$message({
                        message: responseData.message,
                        type: "error",
                     })
                  }
               } catch (error) {
                  console.error("error", error)
                  this.$message({
                     message: "操作失败",
                     type: "error",
                  })
               }
            } else {
               this.$message({
                  message: "请填写必填项",
                  type: "error",
               })
               return false
            }
         })
      },

      drawerCancel() {
         if (this.checkDisabled) {
            this.$emit("drawerCancel", false)
         } else {
            this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
               confirmButtonText: "确定",
               cancelButtonText: "取消",
               type: "warning",
            })
               .then(() => {
                  this.$emit("drawerCancel", false)
               })
               .catch(() => { })
         }

      },

      // 会员卡类型选择变化（右侧表格）
      handleCardTypeSelectionChange(selection) {
         this.selectedCardTypes = selection;
         // 同步更新复选框选中的ID
         this.selectedCardTypeIds = selection.map(item => item.capId);
      },

      // 门店选择变化
      handleStoreSelectionChange(selection) {
         console.log(selection, 'selection');

         this.selectedStores = selection;
      },

      // 会员要求变化处理
      handleMemberTypeChange() {
         // 当会员要求不是"会员积分"时，清空积分要求字段
         if (this.sendDataInfo.memReq !== 3) {
            this.sendDataInfo.memReqPoint = '';
         }
         // 当会员要求不是"会员卡类型"时，清空会员卡类型选择
         if (this.sendDataInfo.memReq !== 2) {
            this.selectedCardTypeIds = [];
            this.selectedCardTypes = [];
         }
         // 当会员要求不是"会员"时，清空会员选择
         if (this.sendDataInfo.memReq !== 1) {
            this.selectedMemberIds = [];
            this.selectedMembers = [];
         }
      },

      // 促销类型变化处理
      handlePromotionTypeChange(value) {
         // 清空商品列表
         this.sendDataInfo.specialList = [];

         // 重置特价与打折参与设置
         this.sendDataInfo.mzIsPileOther = '0';

         if (value == '1') {
            // 清空其他条件，只保留整单金额
            this.sendDataInfo.mzConBgmNum = '';
            this.sendDataInfo.mzConBgmMoney = '';
            this.sendDataInfo.mzBgmTypeNum = '';
            this.sendDataInfo.goodsCategory = '';
            this.sendDataInfo.mzPileType = [];
         } else if (value == '2') {
            // 按商品促销时，清空整单金额
            this.sendDataInfo.mzOrderMoney = '';
            this.sendDataInfo.goodsCategory = '';
            // 确保其他条件可用
            if (!this.sendDataInfo.mzConBgmNum) this.sendDataInfo.mzConBgmNum = '';
            if (!this.sendDataInfo.mzConBgmMoney) this.sendDataInfo.mzConBgmMoney = '';
            if (!this.sendDataInfo.mzBgmTypeNum) this.sendDataInfo.mzBgmTypeNum = '';
            this.sendDataInfo.mzPileType = [];
         }
         // 更新表单验证规则
         this.$nextTick(() => {
            if (this.$refs.sendDataInfo) {
               this.$refs.sendDataInfo.clearValidate();
            }
         });
      },

      // 会员卡类型复选框变化处理
      handleCardTypeCheckboxChange() {
         // 由于现在使用单独的复选框，selectedCardTypeIds已经通过v-model自动更新
         this.selectedCardTypes = this.cardTypeList.filter(item => this.selectedCardTypeIds.includes(item.capId));
      },

      // 处理单个会员卡类型复选框变化
      handleSingleCardTypeChange(capId, checked) {
         if (checked) {
            if (!this.selectedCardTypeIds.includes(capId)) {
               this.selectedCardTypeIds.push(capId);
            }
         } else {
            const index = this.selectedCardTypeIds.indexOf(capId);
            if (index > -1) {
               this.selectedCardTypeIds.splice(index, 1);
            }
         }
         this.selectedCardTypes = this.cardTypeList.filter(item => this.selectedCardTypeIds.includes(item.capId));
      },

      // 处理单个会员复选框变化
      handleSingleMemberChange(memberId, checked) {
         if (checked) {
            if (!this.selectedMemberIds.includes(memberId)) {
               this.selectedMemberIds.push(memberId);
            }
         } else {
            const index = this.selectedMemberIds.indexOf(memberId);
            if (index > -1) {
               this.selectedMemberIds.splice(index, 1);
            }
         }
         this.selectedMembers = this.memberList.filter(item => this.selectedMemberIds.includes(item.memberId));
      },

      // 全选/取消全选会员卡类型
      toggleAllCardTypes() {
         this.$nextTick(() => {
            if (this.isAllSelected) {
               // 全选
               this.selectedCardTypeIds = [...this.cardTypeList.map(item => item.capId)];
               this.selectedCardTypes = [...this.cardTypeList];
            } else {
               // 取消全选
               this.selectedCardTypeIds = [];
               this.selectedCardTypes = [];
            }
         });
      },

      // 全选/取消全选会员
      toggleAllMembers() {
         if (this.selectedMemberIds.length === this.memberList.length) {
            // 取消全选
            this.selectedMemberIds = [];
            this.selectedMembers = [];
         } else {
            // 全选
            this.selectedMemberIds = this.memberList.map(item => item.memberId);
            this.selectedMembers = [...this.memberList];
         }
      },



      // 加载会员卡类型数据
      async loadCardTypeData() {
         try {
            let res = await this.$http.queryMemCardType({
               businessId: "",
               creater: 0,
               ormId: 0,
               page: 1,
               rows: 100,
               start: "",
               end: "",
               capName: "",
            })

            if (res.status == 200) {
               this.cardTypeList = res.result.list || []

            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取会员卡类型数据失败',
               type: "error",
            })
         }
      },

      // 加载会员数据
      async loadMemberData() {
         try {
            let res = await this.$http.queryMembermastList({
               businessId: "",
               creater: 0,
               ormId: 0,
               page: 1,
               rows: 1000,
               start: "",
               end: "",
               memName: "",
               memPhone: ""

            })

            if (res.status == 200) {
               this.memberList = res.result.list || []
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取会员数据失败',
               type: "error",
            })
         }
      },

      // 加载门店数据
      async loadStoreData() {
         try {
            let res = await this.$http.storemastQueryAll({
               businessId: "",
               creater: 0,
               end: 0,
               ormId: 0,
               page: 1,
               rows: 1000,
               start: 0,
               storeName: "",
               storeType: ""
            })

            if (res.status == 200) {
               this.storeList = res.result || []
            } else {
               this.$message({
                  message: res.message,
                  type: "error",
               })
            }
         } catch (error) {
            this.$message({
               message: '获取门店数据失败',
               type: "error",
            })
         }
      },

      // 获取价格设置显示文本
      getPriceSettingText(type) {
         const typeMap = {
            1: '价格不变',
            2: '全部恢复原价',
            3: '数量要求部分恢复原价'
         };
         return typeMap[type] || '';
      },

      // 处理促销方式变化
      handlePromotionMethodChange(value) {
         // 重置所有相关字段
         this.sendDataInfo.mzIsRepeat = 0;
         this.sendDataInfo.mzCashBack = "";
         this.sendDataInfo.mzDiscount = "";
         this.sendDataInfo.mzAddPoint = "";
         this.sendDataInfo.mzReducePoint = "";
         this.sendDataInfo.mzGiftNum = "";

         // 根据不同促销方式设置字段默认值或显示状态
         switch (value) {
            case '5':
               // 原品金额减免，只启用返现金额字段
               this.sendDataInfo.mzCashBack = "0";
               break;
            case '4':
               // 原品打折，只启用折扣字段
               this.sendDataInfo.mzDiscount = "0";
               break;
            case '3':
               // 原品金额减免积分，只启用赠送积分字段
               this.sendDataInfo.mzAddPoint = "0";
               break;
            case '1':
               break;
            case '2':
               // 赠品和优惠券，启用冲减积分和赠送品种数量字段
               this.sendDataInfo.mzReducePoint = "0";
               this.sendDataInfo.mzGiftNum = "1";
               break;
            default:
               break;
         }
      },

      // 添加赠品
      addGiftDetails() {
         var flag = false;
         if (this.sendDataInfo.giftList.length > 0) {
            this.sendDataInfo.giftList.forEach((item) => {
               if (item.bgmId == "") {
                  flag = true;
                  this.$nextTick(() => {
                     this.selectedGiftIndex = Number(
                        this.sendDataInfo.giftList.length - 1
                     );
                     this.tableNextFocus("giftBgmName", this.selectedGiftIndex);
                     let refsElTable = this.$refs.giftTableRef;
                     if (refsElTable) {
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                           this.sendDataInfo.giftList[
                           this.selectedGiftIndex
                           ]
                        );
                     }
                  });
               }
            });
         }
         if (flag) {
            return;
         }
         this.sendDataInfo.giftList.push({});
         var index = this.sendDataInfo.giftList.length - 1;
         for (const key in this.giftDetailsInfo) {
            this.$set(
               this.sendDataInfo.giftList[index],
               key,
               this.giftDetailsInfo[key]
            );
         }
         this.$nextTick(() => {
            this.selectedGiftIndex = Number(
               this.sendDataInfo.giftList.length - 1
            );
            this.tableNextFocus("giftBgmName", this.selectedGiftIndex);
            let refsElTable = this.$refs.giftTableRef;
            if (refsElTable) {
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(
                  this.sendDataInfo.giftList[this.selectedGiftIndex]
               );
            }
         });
      },

      // 删除赠品
      deleteGiftDetails() {
         if (this.sendDataInfo.giftList.length > 0) {
            this.sendDataInfo.giftList.splice(this.selectedGiftIndex, 1);
            this.selectedGiftIndex = 0;
         } else {
            return this.$message({
               message: "暂无可删除赠品",
               type: "warning",
            });
         }
      },

      // 双击赠品行
      openGiftDetailsBox(row, column, event) {
         this.editGiftDetailsIndex = row.index;
         this.giftList = JSON.parse(JSON.stringify(row));
      },
      // -----------------通用名称列表-----------------
      searchCommonNames() {
         this.currentPage = 1;
         this.getDataCommonNames();
      },
      chooseAll() {

         this.pageSize = 3000
         this.getDataCommonNames();

      },
      async getDataCommonNames() {
         let params = {
            businessId: "",
            bgmName: this.searchForm.bgmName,
            manufacturer: this.searchForm.manufacturer,
            page: this.currentPage,
            rows: this.pageSize,

            start: '',
            end: '',
            ormId: 0
         };
         let responseData = await this.$http.getBgmListByType(params);
         if (responseData.status == 200) {
            this.commonNamesList = responseData.result.list;
            this.total = responseData.result.total;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      handleCommonNameSelectionChange(val) {
         this.selectedCommonNames = val.map(item => item.bgmId);
      },
      submitCommonNameSelection() {
         // 判断是否有选中的商品
         if ((!this.selectedCommonNames || this.selectedCommonNames.length === 0) &&
            (!this.selectedAllCommonNames || !this.allCommonNamesIds || this.allCommonNamesIds.length === 0)) {
            this.$message({
               message: "请至少选择一个商品",
               type: "warning"
            });
            return;
         }

         // 根据是否选择全部，确定要处理的商品数据
         let processItems = [];
         let processCount = 0;

         if (this.selectedAllCommonNames && this.allCommonNamesList && this.allCommonNamesList.length > 0) {
            // 处理全部选择的情况
            processItems = this.allCommonNamesList;
            processCount = processItems.length;
         } else {
            // 处理普通选择的情况
            processItems = this.commonNamesList.filter(item =>
               this.selectedCommonNames.includes(item.bgmId)
            );
            processCount = processItems.length;
         }

         // 添加商品到列表
         let addedCount = 0;
         processItems.forEach(item => {
            // 检查是否已存在相同的商品
            const exists = this.sendDataInfo.specialList.some(
               existingItem => existingItem.bgmId === item.bgmId
            );

            if (!exists) {
               // 添加到商品列表
               this.sendDataInfo.specialList.push({
                  bgmId: item.bgmId,
                  bgmName: item.bgmName,
                  bgmCode: item.bgmCode,
                  spec: item.spec,
                  manufacturer: item.manufacturer,
                  retailPrice: item.retailPrice,
                  placeorigin: item.placeorigin,
                  itemQtyRequired: "",
                  itemAmountRequired: "",
                  priceSettingType: 1
               });
               addedCount++;
            }
         });

         this.$message({
            message: `已添加 ${addedCount} 个商品到${this.isExcludeGoodsMode ? '不参与' : '参与'}商品列表`,
            type: "success"
         });

         // 关闭对话框
         this.shopListVisible = false;

         // 重置选择状态
         this.selectedAllCommonNames = false;
         this.allCommonNamesList = [];
         this.allCommonNamesIds = [];
      },
      handleSizeChange(val) {
         this.pageSize = val;
         this.getDataCommonNames();
      },
      handleCurrentChange(val) {
         this.currentPage = val;
         this.getDataCommonNames();
      },

      async selectAllCommonNames() {
         try {
            this.$message({
               message: "正在获取所有商品数据，请稍候...",
               type: "info"
            });

            // 保存当前查询条件
            const params = {
               businessId: "",
               bgmName: this.searchForm.bgmName,
               manufacturer: this.searchForm.manufacturer,
               page: 1,
               rows: 3000, // 一次性获取大量数据
               start: '',
               end: '',
               ormId: 0
            };

            // 获取所有数据
            let responseData = await this.$http.getBgmListByType(params);
            if (responseData.status == 200) {
               // 显示选择的商品数量
               this.$message({
                  message: `已选择全部 ${responseData.result.total} 个商品`,
                  type: "success"
               });

               // 保存所有商品数据
               this.allCommonNamesList = responseData.result.list || [];

               // 设置选中状态
               if (this.$refs.commonNamesTable) {
                  // 先清空当前选中状态
                  this.$refs.commonNamesTable.clearSelection();

                  // 设置当前页面的商品为选中状态
                  this.commonNamesList.forEach(row => {
                     this.$refs.commonNamesTable.toggleRowSelection(row, true);
                  });
               }

               // 保存所有商品的ID
               this.selectedAllCommonNames = true;
               this.allCommonNamesIds = this.allCommonNamesList.map(item => item.bgmId);
            } else {
               this.$message({
                  message: responseData.message || "获取全部商品失败",
                  type: "error"
               });
            }
         } catch (error) {
            console.error("获取全部商品出错:", error);
            this.$message({
               message: "获取全部商品出错",
               type: "error"
            });
         }
      },
   },

   created() {
      this.openBox()
      this.getTypeList()
   },

   beforeDestroy() {
   },
}
</script>
<style scoped>
:deep(.v_tabs_bottom) {
   background-color: #f0f1f4 !important;
}



.dialog-footer {
   display: flex;
   justify-content: center;
   align-items: center;
   width: 100%;
   background: #fff;
   height: 46px;
   padding: 5px 10px;
   margin-top: 20px;
   border-top: 1px solid #eee;

}

#smManrange {
   width: 100%;
   display: flex;
   padding-left: 83px;
   margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content {
   width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner {
   width: 76% !important;
   margin-right: 20px;
   font-size: 12px;
}

.cmContent {
   padding-left: 10px;
   width: 90%;
}

.ellipsis-cell {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   display: block;
   width: 100%;
}

/* 表格滚动样式 */
::v-deep .el-table {
   overflow-y: auto;
}

::v-deep .el-table__body-wrapper {
   overflow-y: auto;
   height: 100%;
}


/* 新的促销设置布局样式 */
.main-layout {
   min-height: 100vh;
   position: relative;
}

.left-section {
   width: 100%;
   /* 减去右侧区域宽度(300px)和间距(40px) */
   display: flex;
   flex-direction: column;
   min-width: 0;
   padding-bottom: 60px;
   /* 为底部按钮留出空间 */
   padding-right: 20px;
   /* 为右侧区域留出间距 */
   box-sizing: border-box;
   /* 确保padding包含在宽度内 */

   /* 确保不超过最大宽度 */
   overflow-x: hidden;
   /* 防止水平溢出 */
}

.right-section {
   width: 30%;

   min-width: 450px;
   width: 300px;
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
   display: flex;
   flex-direction: column;
   overflow: hidden;
   /* 减去顶部和底部的空间 */
   position: fixed;
   /* 固定定位 */
   top: 13px;
   /* 距离顶部20px */
   right: 20px;
   /* 距离右侧20px */
   z-index: 1001;
   /* 确保在左侧内容之上 */
}

.right-content {
   padding: 15px;
   flex: 1;
   display: flex;
   flex-direction: column;
   overflow-y: auto;
   height: 100%;
   /* 确保内容区域占满高度 */
}


.right-content h3 {
   margin: 0 0 15px 0;
   font-size: 16px;
   font-weight: 600;
   color: #303133;
   border-bottom: 2px solid #409eff;
   padding-bottom: 10px;
}

.right-content p {
   margin: 0;
   color: #606266;
   font-size: 14px;
   line-height: 1.5;
}


.right-content::-webkit-scrollbar {
   width: 4px;
}

.right-content::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 2px;
}

.right-content::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 2px;
}

.right-content::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.form-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
   /* 防止被压缩 */
}

.promotion-container {
   display: flex;
   flex: 1;
   min-height: 0;
   overflow: visible;
   margin-bottom: 20px;
}

.promotion-section {
   margin-top: 10px;
   width: 100%;
   /* background: #fff; */
   /* border: 1px solid #e4e7ed; */
   /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); */
   display: flex;
   flex-direction: column;
   overflow: hidden;
}

.condition-section {
   width: 100%;
}

.section-header {
   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
   color: white;
   padding: 20px 25px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: relative;
   flex-shrink: 0;
}



.header-left h3 {
   margin: 0 0 5px 0;
   font-size: 18px;
   font-weight: 600;
   display: flex;
   align-items: center;
}

.section-desc {
   margin: 0;
   font-size: 13px;
   opacity: 0.9;
   font-weight: 400;
}

.header-actions-box {
   display: flex;
   gap: 10px;
   box-sizing: border-box;
}


.section-content {
   display: flex;
   flex-direction: column;
   flex: 1;
   /* 占据剩余空间 */
   height: 100%;
   /* 确保占满父容器高度 */
   overflow: hidden;
   /* 防止出现双滚动条 */
   min-height: 0;
}

/* 类型选择器样式 */
.type-selector {
   background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
   padding: 20px;
   border: 1px solid #e4e7ed;
   flex-shrink: 0;
}

/* 商品列表容器样式 */
.goods-list-container {
   background: #fff;
   border: 1px solid #e4e7ed;
   /* overflow: hidden; */
   flex: 1;
   display: flex;
   flex-direction: column;
   overflow: hidden;
   min-height: 0;
}

.list-header {
   background: #f5f7fa;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e4e7ed;
   flex-shrink: 0;
}

.list-title {
   font-size: 14px;
   font-weight: 600;
   color: #303133;
}

.list-count {
   font-size: 12px;
   color: #606266;
   padding: 4px 8px;
   background: rgba(64, 158, 255, 0.1);
   border-radius: 4px;
   border: 1px solid rgba(64, 158, 255, 0.2);
}

.goods-table-wrapper {
   padding: 0;
   flex: 1;
   overflow: visible;
   /* min-height: 400px; */

}

/* 阶梯阶梯设置样式 */
.step-scheme-container {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   flex: 1;
   display: flex;
   flex-direction: column;
   height: 100%;
   /* 确保占满父容器高度 */
   min-height: 400px;
   /* 设置最小高度 */
}

.scheme-layout {
   display: flex;
   flex: 1;
   /* 占据剩余空间 */
   height: 100%;
   /* 确保占满父容器高度 */
   overflow: hidden;
   /* 防止出现双滚动条 */
}

.scheme-list {
   width: 22%;
   border-right: 1px solid #e4e7ed;
   display: flex;
   flex-direction: column;
   background: #fafafa;
   height: 100%;
   /* 确保占满父容器高度 */
}

.scheme-list .list-header {
   flex-shrink: 0;
   /* 防止头部被压缩 */
   background: #f5f7fa;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e4e7ed;
}

/* 右侧商品管理样式 */
.scheme-goods {
   width: 78%;
   display: flex;
   flex-direction: column;
   background: #fff;
   height: 100%;
   /* 确保占满父容器高度 */
}

.scheme-items {
   flex: 1;
   /* 占据剩余空间 */
   overflow-y: auto;
   /* 垂直滚动 */
   overflow-x: hidden;
   /* 隐藏水平滚动 */
   padding: 15px;
   height: 100%;
   /* 铺满100%高度 */
}

/* 自定义滚动条样式 */
.scheme-items::-webkit-scrollbar {
   width: 6px;
}

.scheme-items::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 3px;
}

.scheme-items::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 3px;
}

.scheme-items::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.scheme-item {
   display: flex;
   justify-content: space-between;
   align-items: center;
   padding: 15px;
   margin-bottom: 10px;
   border: 2px solid #e4e7ed;
   border-radius: 8px;
   cursor: pointer;
   transition: all 0.3s ease;
   background: #fff;
   position: relative;
   /* overflow: hidden; */
}


.scheme-item:hover {
   border-color: #409eff;
   box-shadow: 0 4px 16px rgba(64, 158, 255, 0.15);
   transform: translateY(-2px);
}



.scheme-item.active {
   border-color: #409eff;
   background: linear-gradient(135deg, #ecf5ff 0%, #f0f9ff 100%);
   box-shadow: 0 6px 20px rgba(64, 158, 255, 0.2);
   transform: translateY(-2px);
}


.scheme-info {
   flex: 1;
   display: flex;
   flex-direction: column;
   gap: 5px;
}

.scheme-title {
   font-weight: 600;
   color: #303133;
   font-size: 14px;
}

.scheme-desc {
   color: #909399;
   font-size: 12px;
   white-space: nowrap;
   /* overflow: hidden; */
   text-overflow: ellipsis;
}

.scheme-goods-count {
   color: #409eff;
   font-size: 11px;
   font-weight: 500;
   padding: 2px 6px;
   background: rgba(64, 158, 255, 0.1);
   border-radius: 3px;
   display: inline-block;
   width: fit-content;
}

.scheme-actions {
   opacity: 0;
   transition: opacity 0.3s ease;
}

.scheme-item:hover .scheme-actions,
.scheme-item.active .scheme-actions {
   opacity: 1;
}

.quick-actions {
   display: flex;
   flex-direction: column;
   gap: 10px;
}

.quick-actions .el-button {
   width: 100%;
   justify-content: center;
}

/* 右侧区域新样式 */
.card-type-section,
.store-section {
   margin-bottom: 16px;
   background: #fff;
   border: 1px solid #e8eaed;
   border-radius: 6px;
   overflow: hidden;
   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.card-type-section .section-header,
.store-section .section-header {
   background: #f8f9fa;
   border-bottom: 1px solid #e8eaed;
   padding: 12px 16px;
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.header-content {
   display: flex;
   align-items: center;
   gap: 8px;
   font-size: 14px;
   font-weight: 500;
   color: #2c3e50;
}

.header-content i {
   font-size: 16px;
   color: #5a6c7d;
}

.selection-count {
   background: #e3f2fd;
   color: #1976d2;
   padding: 4px 8px;
   border-radius: 12px;
   font-size: 12px;
   font-weight: 500;
   min-width: 40px;
   text-align: center;
}

.table-container {
   padding: 0;
   background: #fff;
}

/* 卡片类型项目样式 */
.card-code-text {
   font-size: 12px;
   color: #5a6c7d;
   font-weight: 500;
   background: #f5f6fa;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.card-name-text {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.mzDiscount-text {
   font-size: 12px;
   color: #e74c3c;
   font-weight: 500;
   background: #fdf2f2;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.no-mzDiscount {
   font-size: 12px;
   color: #95a5a6;
   font-style: italic;
}

/* 门店项目样式 */
.store-name-text {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.store-type-text {
   font-size: 12px;
   color: #5a6c7d;
   background: #f0f2f5;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

.store-phone-text {
   font-size: 12px;
   color: #3498db;
   font-weight: 500;
}

.store-address-text {
   font-size: 12px;
   color: #7f8c8d;
   line-height: 1.3;
   max-width: 140px;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   display: block;
}

.store-area-text {
   font-size: 12px;
   color: #27ae60;
   background: #f0f9f4;
   padding: 3px 6px;
   border-radius: 3px;
   display: inline-block;
}

/* 表格样式优化 */
::v-deep .el-table--mini {
   font-size: 12px;
   border: none;
}

::v-deep .el-table--mini .el-table__header th {
   background-color: #fafbfc;
   color: #5a6c7d;
   font-weight: 500;
   border-bottom: 1px solid #e8eaed;
   padding: 10px 0;
}

::v-deep .el-table--mini .el-table__body td {
   padding: 8px 0;
   border-bottom: 1px solid #f5f6fa;
}

::v-deep .el-table--mini .el-table__body tr:hover>td {
   background-color: #f8f9fa;
}

::v-deep .el-table--mini .el-table__body tr:last-child>td {
   border-bottom: none;
}

/* 优雅表格样式 */
.elegant-table {
   border: none;
}

.elegant-table .el-table__header-wrapper {
   border-bottom: 1px solid #e8eaed;
}

.elegant-table .el-table__body-wrapper {
   background: #fff;
}




:deep(.el-table thead) {
   height: 40px !important;
}

/* 会员卡类型选择区域样式 */
.card-type-selection {
   border: 1px solid #e4e7ed;
   border-radius: 6px;
   background: #fff;
   overflow: hidden;
}

/* 会员选择区域样式 */
.member-selection {
   border: 1px solid #e4e7ed;
   border-radius: 6px;
   background: #fff;
   overflow: hidden;
}

.member-table {
   background: #fff;
}

.member-list {
   max-height: 200px;
   overflow-y: auto;
}

.member-item {
   display: flex;
   align-items: center;
   padding: 12px 16px;
   border-bottom: 1px solid #f5f6fa;
   transition: all 0.2s ease;
}

.member-item:hover {
   background: #f8f9fa;
}

.member-item:last-child {
   border-bottom: none;
}

.item-card {
   width: 120px;
   text-align: center;
   font-size: 12px;
   font-weight: 500;
   margin: 0 8px;
}

.item-type {
   width: 50px;
   text-align: center;
   font-size: 12px;
   margin: 0 8px;
}

.item-phone {
   width: 120px;
   text-align: center;
   font-size: 12px;
   color: #3498db;
   font-weight: 500;
}

.header-card {
   width: 120px;
   text-align: center;
}

.header-type {
   width: 100px;
   text-align: center;
}

.header-phone {
   width: 120px;
   text-align: center;
}

.selection-header {
   background: #f8f9fa;
   padding: 12px 16px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   border-bottom: 1px solid #e8eaed;
}

.selection-title {
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.card-type-table {
   background: #fff;
}

.table-header {
   display: flex;
   align-items: center;
   background: #fafbfc;
   border-bottom: 1px solid #e8eaed;
   padding: 12px 16px;
   font-weight: 500;
   color: #5a6c7d;
   font-size: 13px;
}

.header-checkbox {
   display: flex;
   align-items: center;
}

.header-text {
   margin-left: 8px;
}

.header-code {
   width: 120px;
   text-align: center;
}

.header-name {
   flex: 1;
   text-align: center;
}

.header-mzDiscount {
   width: 100px;
   text-align: center;
}

.card-type-list {
   max-height: 200px;
   overflow-y: auto;
}

.card-type-list::-webkit-scrollbar {
   width: 4px;
}

.card-type-list::-webkit-scrollbar-track {
   background: #f1f1f1;
   border-radius: 2px;
}

.card-type-list::-webkit-scrollbar-thumb {
   background: #c1c1c1;
   border-radius: 2px;
}

.card-type-list::-webkit-scrollbar-thumb:hover {
   background: #a8a8a8;
}

.card-type-item {
   display: flex;
   align-items: center;
   padding: 12px 16px;
   border-bottom: 1px solid #f5f6fa;
   transition: all 0.2s ease;
}

.card-type-item:hover {
   background: #f8f9fa;
}

.card-type-item:last-child {
   border-bottom: none;
}

.item-checkbox {

   display: flex;
   align-items: center;
}

.item-code {
   width: 120px;
   text-align: center;
   font-size: 12px;

   font-weight: 500;

   margin: 0 8px;
}

.item-name {
   flex: 1;
   text-align: center;
   font-size: 13px;
   font-weight: 500;
   color: #2c3e50;
}

.item-mzDiscount {
   width: 100px;
   text-align: center;
}

.card-mzDiscount {
   font-size: 12px;
   color: #e74c3c;
   font-weight: 500;
   background: #fdf2f2;
   padding: 4px 8px;
   border-radius: 3px;
}

.card-no-mzDiscount {
   font-size: 12px;
   color: #95a5a6;
   font-style: italic;
}

/* 复选框样式优化 */
::v-deep .el-checkbox {
   width: 100%;
   margin-right: 0;
}

::v-deep .el-checkbox__label {
   width: 100%;
   padding-left: 8px;
}

.promotion-condition-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px 20px 20px 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
}

.condition-title {
   font-size: 16px;
   font-weight: 600;
   color: #303133;
   margin-bottom: 20px;
   border-bottom: 1px solid #ebeef5;
   padding-bottom: 10px;
}

.disabled-container {
   position: relative;
   opacity: 0.7;
   pointer-events: none;
}

.disabled-container::after {
   content: '';
   position: absolute;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   background: rgba(255, 255, 255, 0.4);
   z-index: 10;
}

.disabled-notice {
   display: flex;
   align-items: center;
}

.disabled-notice .el-tag {
   margin-right: 10px;
}

/* 简约版头部样式 */
.section-header-simple {
   background: #f5f7fa;
   color: #333;
   padding: 15px 20px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   position: relative;
   flex-shrink: 0;
   border-bottom: 1px solid #e4e7ed;
}

.header-left-simple h3 {
   margin: 0 0 5px 0;
   font-size: 16px;
   font-weight: 600;
   color: #303133;
}

.section-desc-simple {
   margin: 0;
   font-size: 12px;
   color: #606266;
   font-weight: 400;
}

.header-actions-simple {
   display: flex;
   gap: 10px;
}

/* 促销内容块 */
.promotion-content-section {
   background: #fff;
   border: 1px solid #e4e7ed;
   border-radius: 8px;
   padding: 20px;
   margin-bottom: 20px;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
   flex-shrink: 0;
}


.promotion-content-section .el-form-item {
   margin-bottom: 15px;
}

.promotion-content-section .el-form-item label {
   font-weight: 600;
   margin-bottom: 5px;
}

.promotion-content-section .el-input {
   width: 100%;
}

.promotion-content-section .el-select {
   width: 100%;
}

.promotion-content-section .el-radio-group {
   display: flex;
}

.promotion-content-section .el-radio-button {
   width: 100%;
}

.promotion-content-section .el-checkbox-group {
   display: flex;
   gap: 10px;
}

.promotion-content-section .el-checkbox-button {
   width: 100%;
}

/* 赠品商品表格样式 */
.gift-goods-section {
   /* background: #fff; */
   /* border: 1px solid #e4e7ed; */
   /* border-radius: 8px; */
   /* padding: 20px; */
   margin-top: 20px;
   /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06); */
}


.gift-goods-section .goods-table-wrapper {
   border: 1px solid #ebeef5;
   border-radius: 4px;
   overflow: hidden;
}

#mzMonthDays {
   display: flex;
}

:deep(#mzMonthDays .el-form-item__content) {
   width: 80% !important;
}
</style>